import { Component, inject, OnInit } from '@angular/core';
import { ReleaseService } from '../../../../changelog/release.service';
import { FrameDetectionService } from '../../services/frame-detection.service';

@Component({
  standalone: false,
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  private frameDetectionService = inject(FrameDetectionService);
  private releaseService = inject(ReleaseService);

  public date: string;
  public latest: string;
  public isiFrame: boolean = false;

  public ngOnInit(): void {

    if (this.frameDetectionService.isIframe()) {
      this.isiFrame = true; 
    }

    this.isiFrame = this.frameDetectionService.isIframe();
    this.date = new Date().getFullYear().toString();
    this.latest = this.releaseService.getLatestVersion();
  }
}
